<template>
  <div class="style-general">
    <transition name="slide" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
  #jsd-widget{
    display: none !important;
  }

  @import "~bulma/sass/utilities/_all";
  @import 'bulma-o-steps/bulma-steps.css';

  @import "assets/style/color";
  @import "assets/style/font";
  @import "assets/style/navbar";
  @import "assets/style/tabs";
  @import "assets/style/selection";
  @import "assets/style/accueil";

  @import "~bulma";
  @import "~buefy/src/scss/buefy";

  @import "assets/style/ancre";

  @import "assets/style/opportunite";
  @import "assets/style/detailOpp";
  @import "assets/style/diapo";

</style>



// WEBPACK FOOTER //
// src/Root.vue